export default {
  results: [],
  allColumns: [],
  searchByColumns: [],
  criterieas: [],
  displayFields: [],
  sitesByLoggedInUser: []
};
